export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdzenie AML"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź adres i wybierz blockchain — przeprowadzimy szybki screening."])}
}